import { render, staticRenderFns } from "./business_list.vue?vue&type=template&id=239d2747&scoped=true&"
import script from "./business_list.vue?vue&type=script&lang=js&"
export * from "./business_list.vue?vue&type=script&lang=js&"
import style0 from "./business_list.vue?vue&type=style&index=0&id=239d2747&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d2747",
  null
  
)

export default component.exports